<!--  -->
<template>
  <div class="tanble_box">
    <div>
      <div class="creat_box">
        <el-input v-model="paging.user_name" style="width: 200px;" placeholder="请输入投手" />
        <el-input v-model="paging.wechat_name" style="width: 200px;margin:0 10px" placeholder="请输入公众号名称" />
        <el-button type="primary" icon="el-icon-zoom-in" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="infower">重置</el-button>
        <el-button type="success" icon="el-icon-circle-plus" @click="add">创建</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="nickname"
          align="center"
          label="投手"
          width="180"
        />
        <el-table-column
          prop="nickname"
          align="center"
          label="类型"
          width="180"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.type === 1">投手</div>
            <div v-else>绑定关系</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_notice_leader"
          label="是否通知组长"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.is_notice_leader === 1">是</div>
            <div v-else>否</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_call"
          label="是否电话通知"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.is_call === 1">是</div>
            <div v-else>否</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          align="center"
          label="绑定关系"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.wechat_names">{{ JSON.parse(scope.row.wechat_names).join(',') }}</div>
            <div v-else>暂无绑定关系</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          align="center"
          label="配置参数"
        >
          <template slot-scope="scope">
            <div v-for="item,index in scope.row.config_json" :key="index">
              {{ item.desc }} {{ item.value_min }} - {{ item.value_max }} {{ item.start_hi }}-{{ item.end_hi }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="edit(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="deleter(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="阀值"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="50%"
    >
      <threSholddialog ref="themeview" @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import { thresholdlist, deletebindthresholdconfigs } from '@/api/releaseGroup.js'
import threSholddialog from './components/threSholddialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight, threSholddialog },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      total: null,
      tableData: [],
      // 分页信息
      paging: {
        user_name: null,
        wechat_name: null,
        page: 1,
        page_size: 10
      }
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {

  },
  methods: {
    // 请求列表
    async getDataList() {
      this.loading = true
      const data = await thresholdlist(this.paging)
      this.total = data.data.count
      this.tableData = data.data.list
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(s) {
      this.paging.page_size = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.paging.page = s
      this.getDataList()
    },
    search() {
      this.paging.page = 1
      this.getDataList()
    },
    infower() {
      this.paging.page = 1
      this.paging.page_size = 10
      this.paging.user_name = null
      this.paging.wechat_name = null
      this.getDataList()
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.themeview.send(1)
      })
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.themeview.send(2, item)
        console.log('item', item)
      })
    },
    updata() {
      this.dialogVisible = false
      this.getDataList()
    },
    deleter(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletebindthresholdconfigs(id).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getDataList()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tanble_box{
  padding: 30px;
}
.creat_box{
  margin-bottom: 20px;
}
</style>
